import NextLink from 'next/link';

import { Field, Image, ImageField, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import IsRcniLearningRoute from 'src/utils/isRcniLearningRoute';

import { Button } from 'src/components/basicContent/_Button/Button';

import ArrowUpIconSvg from 'public/icons/ArrowUp.svg';

import styles from './Footer.module.css';

type footerBackToTopProps = {
	fields: {
		RcnLearnLogo: ImageField;
		RcniLearningLogo: ImageField;
		ScrollToTopText: Field<string>;
	};
};

export default function FooterBackToTop(props: footerBackToTopProps): JSX.Element {
	const isRcniLearningRoute = IsRcniLearningRoute();

	return (
		<section className={`${styles.section} pinkDark`}>
			<div className={`${styles.brandBar} ${styles.outerGrid} maxWidth padX padYL`}>
				<NextLink href="/">
					<a className={styles.brandBarLogo}>
						<Image
							media={isRcniLearningRoute ? props.fields.RcniLearningLogo : props.fields.RcnLearnLogo}
							loading="lazy"
							height={37}
							width={200}
						/>
					</a>
				</NextLink>

				<div className={styles.backToTopWrapper}>
					<Button
						title={props.fields.ScrollToTopText?.value}
						onClick={() => {
							window.scrollTo({
								top: 0,
								left: 0,
								behavior: 'smooth',
							});
						}}
						className={`${styles.backToTop} link linkOffset linkHoverWeighted`}
					>
						<span className={styles.arrow}>
							<ArrowUpIconSvg />
						</span>

						<span className={styles.backToTopText}>
							<Text field={props.fields.ScrollToTopText} />
						</span>
					</Button>
				</div>
			</div>
		</section>
	);
}
